import { useState } from "react";
import ModalContainer from "../../Tanda Terima/containers/ModalContainer";
// import { CreateButton } from "../../../CommonElements";
import FormTandaTerima from "./FormTandaTerima";
// import DropdownItem from "../../Staff/components/DropdownItem";

const ModalTambahTandaTerima = ({ create, tandaTerima, resetState, toggle, isOpen }) => {
  const [title] = useState(create ? "Tambah Tanda Terima" : "Sunting Tanda Terima")

  return (
    <ModalContainer
      title={title}
      isOpen={isOpen}
      toggle={toggle}
    >
      <FormTandaTerima resetState={resetState} toggle={toggle} data={tandaTerima}/>
    </ModalContainer>
  );
};

export default ModalTambahTandaTerima;
